// extracted by mini-css-extract-plugin
var _1 = "Menu-module__animatedBackground--VBALW";
var _2 = "Menu-module__check--fjiGF";
var _3 = "Menu-module__danger--Zc0tg";
var _4 = "Menu-module__desktopItemInner--dE7P9";
var _5 = "Menu-module__disabled--CEWMH";
var _6 = "Menu-module__expandedSubMenuItems--mwQep";
var _7 = "Menu-module__fullWidth--S5L9c";
var _8 = "Menu-module__icon--JrDUJ";
var _9 = "Menu-module__invisibleButton--sk3C5";
var _a = "Menu-module__item--xaHbd";
var _b = "Menu-module__itemOuter--f89_p";
var _c = "Menu-module__main--TbhX6";
var _d = "Menu-module__menu--leJKB";
var _e = "Menu-module__mobileItemInner--kTkb9";
var _f = "Menu-module__right--ppaal";
var _10 = "Menu-module__selected--kDaJa";
var _11 = "Menu-module__separator--m40gE";
var _12 = "Menu-module__simpleItem--KEDA5";
var _13 = "Menu-module__wrap--diZbh";
export { _1 as "animatedBackground", _2 as "check", _3 as "danger", _4 as "desktopItemInner", _5 as "disabled", _6 as "expandedSubMenuItems", _7 as "fullWidth", _8 as "icon", _9 as "invisibleButton", _a as "item", _b as "itemOuter", _c as "main", _d as "menu", _e as "mobileItemInner", _f as "right", _10 as "selected", _11 as "separator", _12 as "simpleItem", _13 as "wrap" }
